import { VEHICLE_SEARCH_URL, SearchResponse } from '@cinch-nx/data-search'

export const getSearchAPIData = async (): Promise<SearchResponse> => {
  const response = (await fetch(
    `${VEHICLE_SEARCH_URL}?financeType=any&pageSize=0`,
  ).then((res) => res.json())) as SearchResponse
  return response
}
